import React, { FC, useRef, useState } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Slider,
  Typography,
} from '@mui/material';
import { Edit } from '../../constructor/work/Edit';
import { DirectionSloppedType } from '../../constructor/types';

interface ModeDirectType {
  label: string;
  value: DirectionSloppedType;
}
const ModeDirects: Array<ModeDirectType> = [
  { label: 'Сверху вниз', value: 'topBottom' },
  { label: 'Снизу вверх', value: 'bottomTop' },
  { label: 'Слева на право', value: 'leftRight' },
  { label: 'Справа на лево', value: 'rightLeft' },
];

interface Props {
  updateSloped(): void;
}
export const SlopedSurfaceComponent: FC<Props> = ({ updateSloped }) => {
  const [selectDirect, setSelectDirect] = useState<DirectionSloppedType | null>(() => {
    if (Edit.slopedSurface) {
      return Edit.slopedSurface.direction;
    }
    return null;
  });
  const [currGrad, setCurrGrad] = useState(() => {
    if (Edit.slopedSurface) {
      return Edit.slopedSurface.angleSloped;
    }
    return 0;
  });
  const timerRef = useRef<NodeJS.Timer>();

  const handleChangeSelect = (event: SelectChangeEvent) => {
    const val = event.target.value as DirectionSloppedType;
    if (Edit.slopedSurface) {
      Edit.slopedSurface.direction = val;
      Edit.slopedSurface.updateSlopedArrow();
      setSelectDirect(val);
      updateSloped();
    }
  };
  const handlerSliderChange = (event: Event, value: number | number[]) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    if (Edit.slopedSurface) {
      setCurrGrad(+value);
      Edit.slopedSurface.angleSloped = +value;
      Edit.slopedSurface.updateTextGrad();
      timerRef.current = setTimeout(() => {
        updateSloped();
      }, 1000);
    }
  };

  return (
    <Box width="100%" p="14px 16px" boxSizing="border-box">
      <FormControl
        sx={{
          marginBottom: '20px',
          '&.Mui-disabled': {
            color: '#6e6e6e',
          },
          '& .MuiFormLabel-root.MuiInputLabel-root': {
            color: '#fff',
            '&.Mui-disabled': {
              color: '#6e6e6e',
            },
          },
          '& .MuiOutlinedInput-root': {
            color: '#fff',
            '&.Mui-disabled': {
              color: '#6e6e6e',
            },
            '& fieldset': {
              borderColor: '#fff',
            },
            '&:hover fieldset': {
              borderColor: 'rgb(217,255,78)',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#ffffff',
            },
          },
          '& .MuiSvgIcon-root.MuiSelect-icon': {
            color: '#fff',
            '&.Mui-disabled': {
              color: '#6e6e6e',
            },
          },
        }}
        fullWidth
      >
        <InputLabel color="info" id="demo-simple-select-label">
          Направление уклона
        </InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={selectDirect || ''}
          label="Направление уклона"
          color="secondary"
          onChange={handleChangeSelect}
        >
          {ModeDirects.map(item => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Typography marginBottom="10px" color="#fff">
        {`Уклон =  ${currGrad}°`}
      </Typography>
      <Slider
        // onMouseUp={handlerMouseUpSelect}
        value={currGrad}
        onChange={handlerSliderChange}
        valueLabelDisplay="auto"
        step={0.1}
        min={0}
        max={5}
      />
    </Box>
  );
};
